module.exports = __webpack_public_path__ + "img/cover-time.9d2e4ef5.jpg";